import { useTranslations } from "next-intl";
import { isOmnibusEnabled } from "@/features/diets/helpers/omnibus";
import { getLocalePrice } from "@/lib/utilities";
import { cn } from "@/lib/utils";

// Omnibus (MPL-1835): the lowest price of the 30 days before the reduction,
// always per day (contract pt 7e) and in the main view, next to the price it
// refers to (pt 7c). Renders nothing without the Omnibus flag, whatever the
// caller passes: the line must never reach the page before the flag is on.
export const OmnibusLowestPrice = ({
  lowestPrice,
  className,
  short = false,
}: {
  lowestPrice: number;
  className?: string;
  // Shorter text for the mobile configuration bar.
  short?: boolean;
}) => {
  const t = useTranslations();

  if (!isOmnibusEnabled()) {
    return null;
  }

  return (
    <p
      className={cn(
        "whitespace-normal text-text-subtle text-xs leading-4",
        className,
      )}
      data-pw="omnibus-lowest-price"
    >
      {t(short ? "diets.omnibusLowestPriceShort" : "diets.omnibusLowestPrice", {
        price: getLocalePrice({ price: lowestPrice }),
      })}
    </p>
  );
};
